import { z } from "zod/v4";

import { PluginOptionsSchema_2023_08_20 } from "./2023-08-20";

export const PluginOptionsSchema_2024_05_05 =
  PluginOptionsSchema_2023_08_20.omit({ addTestGroupId: true }).extend({
    addVariationId: z.boolean().nullish(),
    maxCookieSize: z.number().nullish(),
  });
export type PluginOptionsType_2024_05_05 = z.infer<
  typeof PluginOptionsSchema_2024_05_05
>;
